import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../../Layout/PageHeader";
import DynamicDetailGrid from "../../../../Components/Grid/DynamicDetailGrid";
import Table, { Column } from "../../../../Components/Tables/Table";
import FormButton from "../../../../Components/Buttons/FormButton";
import { useEffect, useState } from "react";
import { getPickPlanDetails } from "../service/pickplan.service";
import Loader from "../../../../Components/GlobalLoader/Loader";
import { toUpperCase } from "../../../../Utility/Utility";

export default function PickPlanDetails() {
  const { id } = useParams<{ id: string }>();
  const pageName = `Pick Plan (${id})`;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pickPlan, setPickPlan] = useState<any>(null);

  useEffect(() => {
    fetchPickPlanDetails();
  }, [id]);

  const fetchPickPlanDetails = async () => {
    try {
      setLoading(true);
      const response = await getPickPlanDetails(id!);
      setPickPlan(response.data);
      console.log("Pick Plan Details:", response.data);
    } catch (error) {
      console.error("Error fetching pick plan details:", error);
    } finally {
      setLoading(false);
    }
  };

  const pickplanConditionColumns: Column[] = [
    {
      name: "Column",
      selector: (row: { column: string }) => row.column,
      enableSorting: true,
      width:"30%"
    },
    {
      name: "Operator",
      selector: (row: { operator: string }) => row.operator,
      enableSorting: true,
      width:"30%"
    },
    {
      name: "Value",
      selector: (row: { value: number }) => row.value,
      enableSorting: true,
      width:"30%"
    }
  ];

  const pickplanOrdersColumns: Column[] = [
    {
      name: "Shipment #",
      selector: (row: { orderNumber: string }) => row.orderNumber,
      enableSorting: true,
    },
    {
      name: "No. of Lines",
      selector: (row: { shipToName: string }) => row.shipToName,
      enableSorting: true,
    },
    {
      name: "Bill-to",
      selector: (row: { shipByDate: string }) => row.shipByDate,
      enableSorting: true,
    },
    {
      name: "Ship-to",
      selector: (row: { numOfLines: number }) => row.numOfLines,
      enableSorting: true,
    },
    {
      name: "Ship-by Date",
      selector: (row: { numOfShipment: number }) => row.numOfShipment,
      enableSorting: true,
    },
    {
      name: "Requested Qty",
      selector: (row: { numOfWarehouse: number }) => row.numOfWarehouse,
      enableSorting: true,
    },
    {
      name: "Pick Qty",
      selector: (row: { orderQty: number }) => row.orderQty,
      enableSorting: true,
    },
    {
      name: "Remaining Qty",
      selector: (row: { backorderQty: number }) => row.backorderQty,
      enableSorting: true,
    }
  ];

  const PickPlanDetailData = {
    PickPlanDetailData: [
      { label: "Description", value: pickPlan?.description || '-' },
      { label: "Priority", value: pickPlan?.priority_lookup?.description || '-' },
      { label: "Pick Type", value: pickPlan?.pick_method_lookup?.description || '-' },
      { label: "Drop Location", value: pickPlan?.drop_warehouse_location?.name || '-' },
      { label: "Max Shipments", value: pickPlan?.max_shipment_limit || '-' },
    ],
  };

  const allocationOrderByData = pickPlan?.configs?.order_bys?.map(
    ({ column, dir }: { column: string; dir: string }) => ({
      column,
      direction: dir,
    })
  ) ?? [];

  const allocationOrderByColumns: Column[] = [
      {
        name: "Column",
        selector: (row: { column: string }) => row.column,
      },
      {
        name: "Direction",
        selector: (row: { direction: string }) => toUpperCase(row.direction),
      },
    ];

  const pickPlanConditionData = pickPlan?.configs?.conditions?.map(
    ([column, operator, value]: [string, string, number]) => ({
      position: '?',
      column,
      operator,
      value,
      logicalOperator: '?',
    })
  ) ?? [];

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <PageHeader
        listUrl="/outbound/pick-plans"
        viewType={true}
        isHistoryEnabled={true}
      />

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded d-flex flex-column">
        <DynamicDetailGrid
          customClassName="my-2 col-12"
          isExpandable={false}
          columns={4}
          data={PickPlanDetailData.PickPlanDetailData}
        />
      </div>

      <h5 className="text-start mt-3 mb-1">Conditions</h5>
      <div className="my-2 bg-white rounded py-3 px-3 waves-table">
        <Table
          columns={pickplanConditionColumns}
          data={pickPlanConditionData ?? []}
          CheckboxStatus={false}
          isStripped={true}
          enableScrollbar={true}
          customClassName="waves-condition-table"
        />
      </div>
      <h5 className="text-start mt-3 mb-1">Order By</h5>
      <div className="my-2 bg-white rounded py-3 px-3 waves-table">
        <Table
          columns={allocationOrderByColumns}
          data={allocationOrderByData ?? []}
          CheckboxStatus={false}
          isStripped={true}
          enableScrollbar={true}
          customClassName="waves-condition-table"
        />
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={11}
            className="sph-btn me-4"
            handleClick={() => {
              navigate(`/outbound/pick-plans/edit/${id}`);
            }}
          >
            Edit
          </FormButton>
        </div>
      </div>
    </>
  );
}
